/* PIECE & CO - model landing: add to cart in place, and shop-by-size filtering */
(function () {
  'use strict';

  function initAddToCart(root) {
    root.querySelectorAll('form[data-pcm-add]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;

        event.preventDefault();
        var button = form.querySelector('button');
        var original = button ? button.textContent : '';
        if (button) {
          button.setAttribute('aria-busy', 'true');
          button.textContent = '···';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            if (button) {
              button.removeAttribute('aria-busy');
              button.textContent = original;
            }
            form.submit();
          });
      });
    });
  }

  function initSizeFilter(root) {
    var filter = root.querySelector('[data-pcm-filter-row]');
    if (!filter) return;

    var buttons = filter.querySelectorAll('button');
    var cards = root.querySelectorAll('[data-pcm-sizes]');
    var count = root.querySelector('[data-pcm-count]');
    var total = cards.length;

    function apply(size) {
      var shown = 0;

      cards.forEach(function (card) {
        var available = (card.getAttribute('data-pcm-sizes') || '').split(' ');
        var match = size === 'all' || available.indexOf(size) !== -1;
        card.hidden = !match;
        if (match) shown += 1;

        card.querySelectorAll('.pcm-size button').forEach(function (chip) {
          if (size !== 'all' && chip.textContent.trim() === size) {
            chip.setAttribute('data-match', 'true');
          } else {
            chip.removeAttribute('data-match');
          }
        });
      });

      if (count) {
        count.textContent = size === 'all'
          ? ''
          : shown + ' of ' + total + ' colourways have size ' + size + '.';
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var size = button.getAttribute('data-size');
        var already = button.getAttribute('aria-pressed') === 'true';
        var next = already ? 'all' : size;

        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === next));
        });

        apply(next);
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-pcm-sticky]');
    var anchor = root.querySelector('[data-pcm-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.setAttribute('data-visible', String(!entry.isIntersecting));
      });
    }, { rootMargin: '0px 0px -80% 0px' }).observe(anchor);
  }

  function init(root) {
    if (root.dataset.pcmReady === 'true') return;
    root.dataset.pcmReady = 'true';
    initAddToCart(root);
    initSizeFilter(root);
    initSticky(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pcm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();